import useGetApi from 'src/api/useGetApi';
import { SalesOrderDraft } from 'src/types/application/SalesOrderDraftDTO';

type ApiResponse = {
  stagedPurchaseOrder: SalesOrderDraft;
};

const useSalesOrderDraft = (salesOrderDraftId: string) => {
  return useGetApi<ApiResponse>({
    endpoint: `accounts-receivable/staged-purchase-orders/${salesOrderDraftId}`,
    options: {
      enabled: !!salesOrderDraftId,
    },
  });
};

export default useSalesOrderDraft;
